<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>联系我们</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-blue" v-if="countFlag" @click="newConfigContact">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="dataList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
                  height="550">
          <el-table-column prop="time1" align="center" label="联系电话受理开始时间">
          </el-table-column>
          <el-table-column prop="time2" align="center" label="联系电话受理结束时间">
          </el-table-column>
          <el-table-column prop="phone" align="center" label="联系电话">
          </el-table-column>
          <el-table-column prop="time3" align="center" label="在线客服受理开始时间">
          </el-table-column>
          <el-table-column prop="time4" align="center" label="在线客服受理结束时间">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button style="margin: 5px" class="list-btn btn-blue" @click="editConfigContact(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </table-con>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="20%" @close="closeDialog">
      <el-form label-width="170px" class="add-role-form" :model="configContactDialog" ref="dialogForm">
        <el-form-item label="联系电话受理开始时间：" prop="time1">
          <el-input v-model="configContactDialog.time1" size="small"></el-input>
        </el-form-item>
        <el-form-item label="联系电话受理结束时间：" prop="time2">
          <el-input v-model="configContactDialog.time2" size="small"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="configContactDialog.phone" size="small"></el-input>
        </el-form-item>
        <el-form-item label="在线客服受理开始时间：" prop="time3">
          <el-input v-model="configContactDialog.time3" size="small"></el-input>
        </el-form-item>
        <el-form-item label="在线客服受理结束时间：" prop="time4">
          <el-input v-model="configContactDialog.time4" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'configContact',
  components: { tableCon },
  data () {
    return {
      configContactDialog: {
        id: undefined,
        time4: "",
        time3: "",
        phone: "",
        time1: "",
        time2: "0"
      },
      dialogTitle: "",
      dialogVisible: false,
      dataList: [],
      countFlag:true
    };
  },
  methods: {
    confirmEdit () {
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          const { data: res } = await my.$http.post(
              "/system/contact/edit",
              my.configContactDialog
          );
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.dialogVisible = false;
            my.getDataList();
          } else {
            my.$message.error(res.message);
          }
        }
      });
    },
    closeDialog () {
      this.dialogVisible = false;
    },
    newConfigContact () {
      this.dialogInit();
      this.dialogType = 1;
      this.dialogTitle = "新增";
      this.dialogVisible = true;
    },
    editConfigContact (row) {
      this.dialogType = 0;
      this.dialogTitle = "修改";
      this.dialogInitialize(row);
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.dialogForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    dialogInitialize (row) {
      this.configContactDialog.id = row.id;
      this.configContactDialog.time4 = row.time4;
      this.configContactDialog.time3 = row.time3;
      this.configContactDialog.phone = row.phone;
      this.configContactDialog.time1 = row.time1;
      this.configContactDialog.time2 = row.time2;
    },
    dialogInit () {
      this.configContactDialog.id = undefined;
      this.configContactDialog.time4 = "";
      this.configContactDialog.time3 = "";
      this.configContactDialog.phone = "";
      this.configContactDialog.time1 = "";
      this.configContactDialog.time2 = "";
    },
    async getDataList () {
      const { data: res } = await this.$http.get(
          "system/contact/getContact"
      );
      let configContact = res.data
      if (configContact){
        //创建一个数组
        this.dataList = [configContact];
        this.countFlag = false;
      }
    },
  },
  created () {
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
